import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function Dashboard() {
  const [dashboard, setDashboard] = useState("");
  const [loading, setLoading] = useState(false);
  const [orders, setOrder] = useState("");
  const [filterType, setFilterType] = useState("monthly");

  const navigate = useNavigate();

  useEffect(() => {
    getDashboardData();
  }, []);

  // Fetching Data
  const getDashboardData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/dashboard-data`,
        {
          headers: headers,
        }
      );

      console.log("Response", response);
      if (response.data.statusCode === 200) {
        setDashboard(response.data.result);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getRecentOrder = async (type = filterType) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("sansadToken");

      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/order/get-orders-by-filter?type=${type}`,
        { headers }
      );

      console.log("Response order :", response);

      if (response.data.statusCode === 200) {
        setOrder(response.data.result);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Layout>
        <div className="md:p-10 p-2">
          <ToastContainer />
          {/* Today Reports */}
          <div className="bg-white md:p-6 p-3 rounded-xl shadow-md">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Overall Reports</h2>
              <span className="text-sm text-[#5d5fef]">
                <Link target="_blank" to="/">Go to Website</Link>
              </span>
            </div>
            {/* First Row */}
            <div className="flex gap-4 justify-between flex-wrap mt-10">
              <div
                className="bg-[#d2f0d4] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() => navigate("/admin-panel/user/active-users/1?status=All")}
              >
                <div className="bg-[#7ef186] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.allUsers}</h4>
                  <h3 className="text-sm font-base">Total Users</h3>
                </div>
              </div>
              <div
                className="bg-[#f9dbdc] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() => navigate("/admin-panel/user/active-users/1")}
              >
                <div className="bg-[#f58084] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.activeUsers}
                  </h4>
                  <h3 className="text-sm font-base">Active Users</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    19% more than last day
                  </h3> */}
                </div>
              </div>
              <div
                className="bg-[#e0f5fb] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() => navigate("/admin-panel/user/blocked-users/1")}
              >
                <div className="bg-[#3ed5ff] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.blockedUsers}
                  </h4>
                  <h3 className="text-sm font-base">Blocked Users</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    67% more than last day
                  </h3> */}
                </div>
              </div>
              <div
                className="bg-[#f1e5d8] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() =>
                  navigate("/admin-panel/orders/1")
                }
              >
                <div className="bg-[#fead51] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.allOrders}
                  </h4>
                  <h3 className="text-sm font-base">Orders</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    4% more than last day
                  </h3> */}
                </div>
              </div>
            </div>
            {/* Seconds Row */}
            <div className="flex gap-4 justify-between flex-wrap mt-10">
              <div
                className="bg-[#d2f0d4] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() =>
                  navigate("/admin-panel/orders/1?status=Pending")
                }
              >
                <div className="bg-[#7ef186] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.pendingOrders}
                  </h4>
                  <h3 className="text-sm font-base">Pending Orders</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    8% more than last day
                  </h3> */}
                </div>
              </div>
              <div
                className="bg-[#f9dbdc] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() =>
                  navigate("/admin-panel/orders/1?status=Delivered")
                }
              >
                <div className="bg-[#f58084] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.deliveredOrders}
                  </h4>
                  <h3 className="text-sm font-base">Delivered Orders</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    19% more than last day
                  </h3> */}
                </div>
              </div>
              <div
                className="bg-[#e0f5fb] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() =>
                  navigate("/admin-panel/orders/1?status=Out for Delivery")
                }
              >
                <div className="bg-[#3ed5ff] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.shippedOrders}
                  </h4>
                  <h3 className="text-sm font-base">Out for Delivery Orders</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    67% more than last day
                  </h3> */}
                </div>
              </div>
              <div
                className="bg-[#f1e5d8] p-4 rounded-md h-auto md:w-[230px] w-full cursor-pointer"
                onClick={() =>
                  navigate("/admin-panel/orders/1?status=Cancelled")
                }
              >
                <div className="bg-[#fead51] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">
                    {dashboard.cancelledOrders}
                  </h4>
                  <h3 className="text-sm font-base">Cancelled Orders</h3>
                  {/* <h3 className="text-xs mt-1 font-base text-[#5d5fef]">
                    4% more than last day
                  </h3> */}
                </div>
              </div>
            </div>
          </div>

          {/* Recent Orders */}
          <div className="bg-white md:p-6 p-3 rounded-xl shadow-md mt-12">
            <div className="flex justify-between">
              <h2 className="text-xl font-medium">Recently Orders</h2>
              <div className="flex items-center gap-4 ml-auto">
                <select
                  value={filterType}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setFilterType(selected);
                    getRecentOrder(selected);
                  }}
                  className="border border-gray-300 rounded px-2 py-1 text-sm"
                >
                  <option value="daily">daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                </select>

                <span className="text-sm text-[#5d5fef]">
                  <Link to="/admin-panel/orders/1">Go to Orders</Link>
                </span>
              </div>
            </div>
            <div className="flex gap-4 justify-between flex-wrap mt-10">
              <table className="w-full text-center overflow-auto text-sm">
                <thead>
                  <tr className="border-b">
                    <td className="font-medium py-4">Order Id</td>
                    <td className="font-medium py-4">Payment Method</td>
                    <td className="font-medium py-4">Amount</td>
                    <td className="font-medium py-4">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.recentOrders &&
                    dashboard?.recentOrders.map((item) => (
                      <tr key={item._id} className="border-b">
                        <td className="py-3 text-sm">{item.orderId}</td>
                        <td className="py-3 text-sm">{item.paymentMethod}</td>
                        <td className="py-3 text-sm">{item.amount}</td>
                        <td className="py-3 text-sm">{item.status}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Recent Supports */}
          <div className="bg-white md:p-6 p-3 rounded-xl shadow-md mt-12 ">
            <div className="flex justify-between">
              <h2 className="text-xl font-medium">Recently Supports</h2>
              <span className="text-sm text-[#5d5fef]">
                <Link to="/admin-panel/supports/1">Go to Supports</Link>
              </span>
            </div>
            <div className="flex gap-4 justify-between flex-wrap mt-10 overflow-auto text-sm">
              <table className="w-full text-center">
                <thead>
                  <tr className="border-b">
                    <td className="font-medium py-4 px-2">Description</td>
                    {/* <td className="font-medium py-4">Payment Method</td> */}
                    <td className="font-medium py-4 px-2">Created At</td>
                    <td className="font-medium py-4 px-2">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.recentSupports &&
                    dashboard?.recentSupports.map((item) => (
                      <tr key={item._id} className="border-b">
                        <td className="py-3 text-sm">
                          {item.description.length > 40
                            ? item.description.slice(0, 40) + "..."
                            : item.description}
                        </td>
                        {/* <td className="py-3 text-sm">{item.paymentMethod}</td> */}
                        <td className="py-3 text-sm">
                          {formatDate(item.createdAt)}
                        </td>
                        <td className="py-3 text-sm">{item.status}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Today Reports */}
          {/* <div className="bg-white md:p-6 p-3 rounded-xl shadow-md mt-12">
            <div className="flex justify-between">
              <h2 className="text-xl font-medium">Overall Compilation</h2>
             
            </div>
            <div className="flex gap-x-4 gap-y-10 justify-around flex-wrap mt-10">
              <div className="bg-[#d2f0d4] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[#7ef186] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.allOrders}</h4>
                  <h3 className="text-sm font-base">All Orders</h3>
               
                </div>
              </div>
              <div className="bg-[#f9dbdc] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[#f58084] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.pendingOrders}</h4>
                  <h3 className="text-sm font-base">Pending Orders</h3>
               
                </div>
              </div>
              <div className="bg-[#e0f5fb] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[#3ed5ff] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.deliveredOrders}</h4>
                  <h3 className="text-sm font-base">Delivered Orders</h3>
                 
                </div>
              </div>
              <div className="bg-[#f1e5d8] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[#fead51] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.cancelledOrders}</h4>
                  <h3 className="text-sm font-base">Cancelled Orders</h3>
             
                </div>
              </div>
              <div className="bg-[#e1e1f3] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[#5d5fef] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">{dashboard.shippedOrders}</h4>
                  <h3 className="text-sm font-base">Shipped Orders</h3>
                
                </div>
              </div>
              <div className="bg-[#f5f5d3] p-4 px-5 rounded-md h-auto w-[300px]">
                <div className="bg-[tomato] h-[42px] w-[42px] rounded-full flex justify-center items-center">
                  <i className="fa fa-bar-chart text-white"></i>
                </div>
                <div className="tracking-wide mt-3">
                  <h4 className="text-3xl font-medium">27</h4>
                  <h3 className="text-sm font-base">Levels</h3>
                  <h3 className="text-xs mt-1 font-base text-[#5d5fef] cursor-pointer">
                  Check Levels Management
                  </h3>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </Layout>
    </>
  );
}
